import React from 'react'
import BooksDetail from '../books/BooksDetail'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'
import { useTranslation } from 'react-i18next'

type Props = {}

const JournalDetail = (props: Props) => {
    const { t } = useTranslation()
    return (
        <BooksDetail
            library_category={ELibraryCategory.MAGAZINE}
            library_head_name={t("วารสาร")}
            library_head_pathname={routeName.e_library.journal}
            library_head_list_path={routeName.e_library.journal_list}
        />
    )
}

export default JournalDetail